const SET_MODULE = "SET_MODULE";
const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
const SET_MY_TIMES = "SET_MY_TIMES";
const SET_MY_TIME = "SET_MY_TIME";
const SET_DASHBOARD_ANNOUNCEMENTS = "SET_DASHBOARD_ANNOUNCEMENTS";
const SET_DASHBOARD_MY_TASKS = "SET_DASHBOARD_MY_TASKS";
const SET_DASHBOARD_UPCOMING_EVENTS = "SET_DASHBOARD_UPCOMING_EVENTS";
const SET_PERMITTED_MODULES = "SET_PERMITTED_MODULES";
const SET_USER_MANAGEMENT = "SET_USER_MANAGEMENT";
const SET_ROLE_GROUP = "SET_ROLE_GROUP";
const SET_ROLE_GROUP_ASSOCIATION = "SET_ROLE_GROUP_ASSOCIATION";
const SET_ROLES = "SET_ROLES";
const SET_APPLICATION_LIST = "SET_APPLICATION_LIST";
const SET_APPLICATION_CONTRACT_LIST = "SET_APPLICATION_CONTRACT_LIST";
const SET_USER_ASSOCIATED_ROLE_GROUPS = "SET_USER_ASSOCIATED_ROLE_GROUPS";
const SET_SEARCHED_ROLE_GROUPS = "SET_SEARCHED_ROLE_GROUPS";
const SET_ASSOCIATED_ROLES = "SET_ASSOCIATED_ROLES";
const SET_ASSOCIATION_TYPES = "SET_ASSOCIATION_TYPES";
const SET_EMPLOYEE_ASSOCIATIONS = "SET_EMPLOYEE_ASSOCIATIONS";
const SET_SEARCHED_USER_LIST = "SET_SEARCHED_USER_LIST";
const SET_PROCESS_TYPES = "SET_PROCESS_TYPES";
const SET_WORKFLOWS = "SET_WORKFLOWS";
const SET_ACTIONS = "SET_ACTIONS";
const SET_PROCESS_ASSOCIATIONS = "SET_PROCESS_ASSOCIATIONS";
const SET_USER_GROUPS = "SET_USER_GROUPS";
const SET_USERS_IN_USER_GROUP = "SET_USERS_IN_USER_GROUP";
const SET_AVAILABLE_STATUS = "SET_AVAILABLE_STATUS";
const SET_STATUS_CONFIGURATION = "SET_STATUS_CONFIGURATION";
const SET_USER_GROUP_ASSOCIATION = "SET_USER_GROUP_ASSOCIATION";
const SET_APPROVAL_GROUPS = "SET_APPROVAL_GROUPS";
const SET_USERS_IN_APPROVAL_GROUP = "SET_USERS_IN_APPROVAL_GROUP";
const SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP =
  "SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP";
const SET_AVAILABLE_NEXT_STATUS = "SET_AVAILABLE_NEXT_STATUS";

export {
  SET_AVAILABLE_NEXT_STATUS,
  SET_ASSOCIATED_USER_GROUPS_WITH_APPROVAL_GROUP,
  SET_USERS_IN_APPROVAL_GROUP,
  SET_APPROVAL_GROUPS,
  SET_USER_GROUP_ASSOCIATION,
  SET_STATUS_CONFIGURATION,
  SET_AVAILABLE_STATUS,
  SET_USERS_IN_USER_GROUP,
  SET_USER_GROUPS,
  SET_PROCESS_ASSOCIATIONS,
  SET_ACTIONS,
  SET_WORKFLOWS,
  SET_PROCESS_TYPES,
  SET_MODULE,
  SET_NOTIFICATIONS,
  SET_MY_TIMES,
  SET_MY_TIME,
  SET_DASHBOARD_ANNOUNCEMENTS,
  SET_DASHBOARD_MY_TASKS,
  SET_DASHBOARD_UPCOMING_EVENTS,
  SET_PERMITTED_MODULES,
  SET_USER_MANAGEMENT,
  SET_ROLE_GROUP,
  SET_ROLE_GROUP_ASSOCIATION,
  SET_ROLES,
  SET_APPLICATION_LIST,
  SET_APPLICATION_CONTRACT_LIST,
  SET_USER_ASSOCIATED_ROLE_GROUPS,
  SET_SEARCHED_ROLE_GROUPS,
  SET_ASSOCIATED_ROLES,
  SET_ASSOCIATION_TYPES,
  SET_EMPLOYEE_ASSOCIATIONS,
  SET_SEARCHED_USER_LIST
};
